require("!!/src/node_modules/script-loader/addScript.js")(require("!!/src/node_modules/raw-loader/index.js!/src/node_modules/what-input/dist/what-input.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/what-input/dist/what-input.js
// module id = 1896
// module chunks = 2